import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessStore } from '@/features/access/state/access.store';
import { AuthStore } from '../state/auth.store';

export const authGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

export const loginGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return authStore.isAuthenticated() ? router.createUrlTree(['/']) : true;
};

export const permissionGuard: CanActivateFn = (route) => {
  const access = inject(AccessStore);
  const router = inject(Router);
  const permission = route.data['permission'] as string | undefined;
  const anyOf = (route.data['anyPermission'] as string[] | undefined)?.filter((p) => p.trim());

  if (anyOf?.length) {
    return access.hasAny(anyOf) ? true : router.createUrlTree(['/']);
  }

  if (!permission?.trim()) {
    return router.createUrlTree(['/']);
  }

  return access.has(permission) ? true : router.createUrlTree(['/']);
};
